import { FieldState, FormState } from "formstate";
import { action } from "mobx";
import { PASSWORD_MIN_LENGTH } from "utils/forms/constants";
import { hasNumber, minLength, required } from "utils/forms/validators";

type ChangePasswordFormState = {
  currentPassword: FieldState<string>;
  newPassword: FieldState<string>;
  repeatedPassword: FieldState<string>;
};

class ChangePasswordFormUiStore {
  currentPassword: FieldState<string> = new FieldState("").validators(
    required("register.password.error.required"),
    minLength(PASSWORD_MIN_LENGTH, "register.password.error.minLength"),
    hasNumber("register.password.error.hasNumber")
  );

  newPassword: FieldState<string> = new FieldState("").validators(
    required("register.password.error.required"),
    minLength(PASSWORD_MIN_LENGTH, "register.password.error.minLength"),
    hasNumber("register.password.error.hasNumber")
  );

  repeatedPassword: FieldState<string> = new FieldState("").validators(
    required("register.repeatedPassword.error.required"),
    () => this.passwordsMustMatch()
  );

  form = new FormState<ChangePasswordFormState>({
    currentPassword: this.currentPassword,
    newPassword: this.newPassword,
    repeatedPassword: this.repeatedPassword,
  });

  passwordsMustMatch() {
    return this.newPassword.value === this.repeatedPassword.value
      ? false
      : "register.repeatedPassword.error.match";
  }

  @action
  validateRepeatedPassword = async () => {
    if (!this.repeatedPassword.dirty) {
      return;
    }

    this.repeatedPassword.validate();
  };

  @action
  resetForm() {
    this.currentPassword.reset();
    this.newPassword.reset();
    this.repeatedPassword.reset();
  }
}

export default ChangePasswordFormUiStore;
export const changePasswordFormUiStore = new ChangePasswordFormUiStore();
